import { JsonObject, JsonProperty } from "ta-json";

export type MetricOptionType = "sum" | "avg" | "min" | "max";

@JsonObject()
export class MetricOptionRequestResource {
    @JsonProperty("name")
    name: string;

    @JsonProperty("type")
    type: MetricOptionType;

    @JsonProperty("field")
    field: string;

    constructor(name: string, type: MetricOptionType, field: string) {
        this.name = name;
        this.type = type;
        this.field = field;
    }
}
